//Custom components

import { InformationCircleIcon } from '@heroicons/react/24/outline';
import Card from '@/components/UI/Card/index.tsx';
import { isObjectEmpty } from '@/utils';

const NewJobCreatedByClassification = ({ jobs }: { jobs: { [key: string]: number } }) => {
  return (
    <Card title='New Job Created by Classification'>
      <div className='grid md:grid-col-2 xl:grid-col-2 gap-3 p-5'>
        {!isObjectEmpty(jobs) ? (
          Object.keys(jobs).map((key: string) => (
            <div key={key} className='col-span-1 flex justify-between'>
              <span>{key}</span>
              <span>{jobs[key]}</span>
            </div>
          ))
        ) : (
          <div className='p-2 mt-2 flex flex-col items-center justify-center gap-2 h-2/6'>
            <span>
              <InformationCircleIcon className='h-8 w-8 text-tertiaryColor-normal' />
            </span>
            <p>No New Job Created By Classification</p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default NewJobCreatedByClassification;
